import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { useIsFirstRender } from '@/hooks/useIsFirstRender';
import { ownerAverageRating } from '@/redux/modules/owner/selectors';
import { getReviews } from '@/redux/modules/reviews';
import { getAverageCampgroundReviewsRatings } from '@/redux/selectors/campgrounds/page';
import { getCampgroundAllReviews } from '@/redux/selectors/campgrounds/reviews';
import { getAverageReviewsRatings } from '@/redux/selectors/listing/page';
import { getAllReviews, getVibeSpotlight } from '@/redux/selectors/listing/reviews';
import { handleReviewLighboxChange } from '@/utility/reviews';

import AllReviews from './AllReviews';

type TAllReviewsContainerProps = {
  listingId?: string;
  isCampground?: boolean;
};
const AllReviewsContainer: React.FC<TAllReviewsContainerProps> = ({ listingId, isCampground }) => {
  const allReviews = useSelector(isCampground ? getCampgroundAllReviews : getAllReviews);
  const categoryRatings = useSelector(
    isCampground ? getAverageCampgroundReviewsRatings : getAverageReviewsRatings,
  );
  const averageRating = useSelector(ownerAverageRating);
  const vibeSpotlight = useSelector(getVibeSpotlight);

  const dispatch = useDispatch();
  // Need first mount so we don't cause flicker on the page when re-rendering reviews if they're already fetched.
  const isMount = useIsFirstRender();

  useEffect(() => {
    if (listingId && isMount && !allReviews?.reviews.length) {
      dispatch(getReviews(listingId, isCampground));
    }
  }, [dispatch, isMount, allReviews, listingId, isCampground]);

  if (!allReviews) {
    return null;
  }

  return (
    <AllReviews
      totalReviews={allReviews.totalReviews}
      averageRating={allReviews.averageRating}
      reviews={allReviews.reviews}
      categoryReviewsRatings={categoryRatings}
      ownerAverageRating={averageRating}
      isCampground={isCampground}
      vibeSpotlight={vibeSpotlight}
      onLightboxChange={handleReviewLighboxChange}
    />
  );
};

export default AllReviewsContainer;
